import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

function ForgotPassword() {
  const [identifier, setIdentifier] = useState('');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    try {
      const res = await axios.post('/api/auth/forgot-password', {
        username_or_email: identifier,
      });
      setMessage(res.data.message);
    } catch {
      // The backend deliberately replies the same way regardless of
      // whether the account exists; show the generic message even on
      // unexpected errors so we don't leak.
      setMessage('אם החשבון קיים, נשלח אליו מייל עם קישור לאיפוס סיסמה');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={handleSubmit}>
        <img src="/logo-icon.png" alt="Huri-Connect" className="login-logo-icon" />
        <h1>איפוס סיסמה</h1>
        <p>הכניסו את שם המשתמש או כתובת המייל שלכם</p>
        {message && <div className="login-info">{message}</div>}
        {!message && (
          <>
            <input
              type="text"
              placeholder="שם משתמש או מייל"
              value={identifier}
              onChange={e => setIdentifier(e.target.value)}
              required
            />
            <button type="submit" disabled={submitting}>
              {submitting ? 'שולח...' : 'שליחת קישור איפוס'}
            </button>
          </>
        )}
        <Link to="/login" className="login-forgot">חזרה לכניסה</Link>
      </form>
    </div>
  );
}

export default ForgotPassword;
